import { render, staticRenderFns } from "./StServiceOverview.vue?vue&type=template&id=15e09654"
import script from "./StServiceOverview.vue?vue&type=script&lang=ts"
export * from "./StServiceOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports